/**
 * Helpers de validación para upload de archivos.
 * Retorna { valid, error } sin efectos secundarios — la UI decide cómo mostrar el error.
 */

import { fData } from "src/utils/formatNumber";

/**
 * Valida un File contra reglas de mime + size.
 * El mensaje de error de tipo asume MIMEs `image/*`; para otros tipos extender el formateo.
 * @param {File} file - Archivo a validar
 * @param {Object} opts - Opciones
 * @param {string[]} opts.acceptedMimes - Mime types aceptados (ej. ["image/jpeg", "image/png"])
 * @param {number} opts.maxSizeBytes - Tamaño máximo en bytes (ej. 5 * 1024 * 1024)
 * @returns {{ valid: boolean, error?: string }}
 */
export const validateUploadFile = (file, { acceptedMimes, maxSizeBytes }) => {
  if (!file) {
    return { valid: false, error: "Archivo requerido." };
  }

  if (acceptedMimes && !acceptedMimes.includes(file.type)) {
    const tiposLegibles = acceptedMimes
      .map((m) => m.replace("image/", ".").replace("jpeg", "jpg"))
      .join(", ");
    return {
      valid: false,
      error: `El tipo de archivo debe ser ${tiposLegibles}.`,
    };
  }

  if (maxSizeBytes && file.size > maxSizeBytes) {
    return {
      valid: false,
      error: `El archivo es demasiado grande. Máximo ${fData(maxSizeBytes)}.`,
    };
  }

  return { valid: true };
};

/**
 * Constantes pre-configuradas para foto de perfil.
 */
export const FOTO_PERFIL_RULES = {
  acceptedMimes: ["image/jpeg", "image/png"],
  maxSizeBytes: 5 * 1024 * 1024, // 5 MB
};
